<template>
  <v-slide-x-transition mode="out-in">
    <router-view />
  </v-slide-x-transition>
</template>
<script>
export default {
  methods: {
    initValidate() {
      const required_id = {
        getMessage: (field) => field + " الزامی است.",
        validate: (value) => {
          if (value.id === undefined || value.id === null) {
            return false;
          }
          return true;
        },
      };
      this.$validator.extend("required_id", required_id);
    },
  },

  created() {
    let lang = { text: "FA", value: "fa", dir: "rtl" };
    if (localStorage.getItem("lang")) {
      lang = JSON.parse(localStorage.getItem("lang"));
    } else {
      localStorage.setItem("lang", JSON.stringify(lang));
    }
    this.$i18n.locale = lang.value;
    this.$store.commit("setLang", lang);
    this.$validator.localize(lang.value);
    this.$vuetify.rtl = lang.dir == "rtl";
    this.$vuetify.lang.current = lang.value;
    localStorage.setItem("lang", JSON.stringify(lang));
  },
};
</script>